import { reducerNames } from 'shared/constants';

export default function reducer(state = {}, action) {
  if (action.reducer === reducerNames.ui) {
    return {
      ...state,
      ...action.state,
    };
  }
  return state;
}
